import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getRoleAPI = (data, callBack) => {
    return async () => {
      try {
        await apiGet(ApiConstants.getRoleUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("get role api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("get role api err:", err);
        throw err;
      }
    };
  };


  export const getAllModulesAPI = (data, callBack) => {
    return async () => {
      try {
        await apiGet(ApiConstants.getAllModuleUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("get all modules api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("get all modules api err:", err);
        throw err;
      }
    };
  };


  export const getRolePermissionByIdAPI = (roleId, callBack) => {
    return async () => {
      try {
        await apiGet(`${ApiConstants.rolePermissionUrl}?role_id=${roleId}`)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("get role permission api api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("get role permission api api err:", err);
        throw err;
      }
    };
  };


  export const addRolePermissionAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPost(ApiConstants.rolePermissionUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("add role permission api api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("add role permission api api err:", err);
        throw err;
      }
    };
  };


  export const updateRolePermissionAPI = (data, callBack) => {
    return async () => {
      try {
        await apiPut(ApiConstants.rolePermissionUrl, data)
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("update role permission api api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("update role permission api api err:", err);
        throw err;
      }
    };
  };

  export const deleteRolePermissionAPI = (roleId, callBack) => {
    return async () => {
      try {
        await apiDelete(
          `${ApiConstants.rolePermissionUrl}?role_id=${roleId}`
        )
          .then((response) => {
            callBack && callBack(response?.data, response?.data);
          })
          .catch((err) => {
            console.log("delete role permission api api err===-=>>>:", err);
            throw err;
          });
      } catch (err) {
        console.log("delete role permission api api err:", err);
        throw err;
      }
    };
  };
  